import { I18nEnum, UserLanguageEnum } from "@/shared/lib/i18n/i18n.types"
import i18n from "@/shared/lib/react-i18next"
import TriangleWarningIcon from "@/assets/triangle-warning-icon.svg?react"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@beringlab/ui"
import { Link } from "@tanstack/react-router"

const OveruseTooltip = ({ isFreeUser }: { isFreeUser: boolean }) => {
  const isKoreanLanguage =
    i18n.language.startsWith(I18nEnum.Ko) ||
    i18n.language.startsWith(UserLanguageEnum.Ko)
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger>
          <TriangleWarningIcon width="18" height="18" className="text-danger" />
        </TooltipTrigger>
        <TooltipContent
          className="max-w-[250px] bg-danger text-white"
          arrowClassName="bg-danger fill-danger"
        >
          {isKoreanLanguage ? (
            <>
              <p>
                {isFreeUser
                  ? "기본 제공 단어 사용량을 초과하셨습니다. 추가로 이용하시려면"
                  : "기본 제공 단어 사용량을 초과하셨습니다. 추가 사용량에 따른 과금을 방지하시려면"}
              </p>
              <Link to="/subscription" className="underline underline-offset-2">
                <p>지금 바로 플랜을 업그레이드하세요 →</p>
              </Link>
            </>
          ) : (
            <>
              <p>
                {isFreeUser
                  ? "You’ve used all of your word translations. If you would like to use it additionally,"
                  : "You’ve used all of your word translations. To avoid any additional charges,"}
              </p>
              <Link to="/subscription" className="underline underline-offset-2">
                <p>upgrade your plan now →</p>
              </Link>
            </>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default OveruseTooltip
